module.exports = __webpack_public_path__ + "assets/img/m23.8d8db192.png";